"use client";

interface TrustpilotWidgetLightProps {
    className?: string;
    locale?: string;
}

const COPY = {
    tr: {
        title: "Trustpilot 4.8/5",
        subtitle: "Gerçek hasta deneyimlerini inceleyin",
    },
    en: {
        title: "Trustpilot reviews 4.8 out of 5",
        subtitle: "Read real patient experiences",
    },
};

function StarIcon() {
    return (
        <svg viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5">
            <path
                fill="currentColor"
                d="M12 1.75l3.14 6.36 7.02 1.02-5.08 4.95 1.2 6.99L12 17.77l-6.28 3.3 1.2-6.99L1.84 9.13l7.02-1.02L12 1.75z"
            />
        </svg>
    );
}

export default function TrustpilotWidgetLight({
    className = "",
    locale = "tr",
}: TrustpilotWidgetLightProps) {
    const isTurkish = locale.toLowerCase().startsWith("tr");
    const copy = isTurkish ? COPY.tr : COPY.en;

    return (
        <a
            href="https://www.trustpilot.com/review/emrahcinik.com"
            target="_blank"
            rel="noopener noreferrer"
            className={`group inline-flex items-center gap-3 text-left ${className}`}
            aria-label={copy.title}
        >
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#00b67a] text-white shadow-sm transition-transform duration-300 group-hover:scale-[1.04]">
                <StarIcon />
            </span>
            <span className="flex flex-col leading-none">
                <span className="mt-1 text-[13px] font-semibold text-[#102a43]">
                    {copy.title}
                </span>
                <span className="mt-1 text-[12px] text-[#4f6476]">
                    {copy.subtitle}
                </span>
            </span>
        </a>
    );
}
